module.exports = __webpack_public_path__ + "static/img/静止.56045d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/货车/静止.png
// module id = SNpY
// module chunks = 76